export default __webpack_public_path__ + "static/media/Cera-Pro-Bold.2c3b37d3.woff";